module.exports = __webpack_public_path__ + "static/media/half_star.ba5c6902.svg";